/**
 * @param key
 * @param trans
 * @param defaultValue
 * @return {*}
 */
export function getUrlParams(key: string, trans?: boolean, defaultValue?: any) {
  try {
    const reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`);
    const r = window.location.search.substr(1).match(reg);

    if (r != null) {
      let res = decodeURIComponent(r[2]);
      if (trans) {
        try {
          res = JSON.parse(res);
        } catch (e) {
          // console.log(e)
        }
      }
      return res;
    }

    return defaultValue || "";
  } catch (err) {
    console.error("获取链接参数失败：", err);
  }
}

/**
 * @param link
 * @param key
 * @return {*}
 */
export function getLinkParams(link: string, key: string) {
  const reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`);

  if (!link.split("?")[1]) {
    return "";
  }

  const r = link.split("?")[1].match(reg);

  if (r != null) {
    return r[2];
  }

  return "";
}

/**
 * encodeFormDataToUrlSearch 将对象转为query string
 * @param {object} data
 * @return {string}
 */
export function encodeFormDataToUrlSearch(obj: any) {
  const keys = Object.keys(obj);
  let str = "";
  keys.forEach((k) => {
    if (obj[k]) {
      str += `&${k}=${encodeURIComponent(obj[k])}`;
    }
  });

  return str.slice(1);
}

export function updateURLArg(argMap: object) {
  try {
    const myURL = parseURL(window.location.href);
    const newUrl = replaceUrlParams(myURL, argMap);
    window.history.replaceState(null, "", newUrl);
  } catch (err) {
    console.error("链接解析失败：", err);
  }
}

function parseURL(url: string) {
  const a = document.createElement("a");
  a.href = url;
  return {
    source: url,
    protocol: a.protocol.replace(":", ""),
    host: a.hostname,
    port: a.port,
    query: a.search,
    params: (function () {
      let ret = {};
      let seg = a.search.replace(/^\?/, "").split("&");
      let len = seg.length;
      let s;
      for (let i = 0; i < len; i++) {
        if (!seg[i]) {
          continue;
        }
        s = seg[i].split("=");
        ret[s[0]] = s[1];
      }
      return ret;
    })(),
    file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ""])[1],
    hash: a.hash.replace("#", ""),
    path: a.pathname.replace(/^([^\/])/, "/$1"),
    relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ""])[1],
    segments: a.pathname.replace(/^\//, "").split("/"),
  };
}

// 替换myUrl中的同名参数值
function replaceUrlParams(myUrl: any, newParams: object) {
  Object.keys(newParams).forEach((x) => {
    let hasInMyUrlParams = false;
    for (let y in myUrl.params) {
      if (x.toLowerCase() === y.toLowerCase()) {
        myUrl.params[y] = newParams[x];
        hasInMyUrlParams = true;
        break;
      }
    }
    // 原来没有的参数则追加
    if (!hasInMyUrlParams) {
      myUrl.params[x] = newParams[x];
    }
  });
  let result = myUrl.protocol + "://" + myUrl.host + ":" + myUrl.port + myUrl.path + "?";

  Object.keys(myUrl.params).forEach((p) => {
    if (myUrl.params[p] !== undefined && myUrl.params[p] !== "") {
      result += p + "=" + myUrl.params[p] + "&";
    }
  });

  if (result.substr(result.length - 1) === "&") {
    result = result.substr(0, result.length - 1);
  }

  if (myUrl.hash !== "") {
    result += "#" + myUrl.hash;
  }
  return result;
}

export function getBlankUrl(url: string) {
  const orgId = getUrlParams("orgId");
  const accountId = getUrlParams("accountId");
  if (orgId && accountId) {
    if (url.includes("?")) {
      url = `${url}&orgId=${orgId}&accountId=${accountId}`;
    } else {
      url = `${url}?orgId=${orgId}&accountId=${accountId}`;
    }
  }
  return url;
}
